import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import MobileSidebar from "./MobileSidebar";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { logger } from "../../helper/Logger";
import { IRootState } from "../../interfaces";
import { LogOutRequest, getProfileRequest, getConfigRequest } from "../../action";
class Layout extends Component<any, any> {
  constructor(props: any) {
    super(props);
    // declaring states
    this.state = {
      open: false,
      show: false,
      sidebar: false,
      searchbar: false,
      submenu: false,
      userImage: "",
      modalLabel: "login",
      mobileView: false,
      mobileClass: "",
      layoutClass: "layout-container",
    };
  }

  componentDidMount = () => {
    this.props.getProfileInfo();
    const menuLink = "portalMenus";
    const data = { menuLink };
    this.props.getConfigInfo({ ...data });
    if (window.location.href.indexOf("/welcome") != -1) {
      this.setState({
        layoutClass: "layout-container welcome-bottom",
      });
    }
    if(window.matchMedia("(max-width: 1024px)").matches) {  
       this.setState({mobileView:true})
    }
  };
  componentDidUpdate = (prevProps: any) => {
    if (
      prevProps.loginReducer &&
      this.props.loginReducer &&
      this.props.loginReducer.isLoading !== prevProps.loginReducer.isLoading &&
      !this.props.loginReducer.error
    ) {
      this.setState({
        show: false,
      });
    }
  };



  handleClose = () => {
    logger("calling............");
    this.setState({
      show: false,
      modalLabel: "login",
    });
  };
  // To handle login & forgot password modal
  handleShow = () => {
    this.setState({ show: true });
  };
  Closesidenav = () => {
    this.setState({ sidebar: false });
  };

  Closesearchbar = () => {
    this.setState({ searchbar: false });
  };
  Opensearchbar = () => {
    this.setState({ searchbar: true });
  };
  // To manage forgot password modal
  forgotShow = () => { 
    this.setState({ show: true, modalLabel: "forgot" });
  };
  resetShow = () => {
    this.setState({ show: true, modalLabel: "reset" });
  }
  // // To manage login modal
  // showLoginModal = () => {
  //   this.setState({ show: true, modalLabel: 'login' });
  // };
  showsubmenu = () => {
    this.setState({ submenu: !this.state.submenu });
  };
  Opensidenav = () => {
    if (this.state.mobileView) {
      this.setState({
        mobileView: false,
        mobileClass: "",
      });
    } else {
      this.setState({
        mobileView: true,
        mobileClass: "show-toggle",
      });
    }
    if(document.getElementById("menu-hover-info") && document.getElementById("menu-hover-info") != null) {
      var a = document.getElementById("menu-hover-info")     
      a.style.display = "none";
    }
  };
 
  render() {
    const { show, modalLabel } = this.state;
    const { loginReducer } = this.props;
    return (
      <><div id="mobileViewClass">
       {this.state.mobileView ? 
            <MobileSidebar
            {...this.props}
            {...this.state}                    /> : ""
          } </div>
        <div className="full-app-wrap">
          {localStorage.getItem("userToken") ? (
            <> 
           
              <Header
                {...this.props}
                {...this.state}
                Opensidenav={this.Opensidenav}
              />
              <section className={this.state.layoutClass} style={{backgroundColor:"#ECE9E9DC"}}>
                <div className="container-fluid">
                  <div className="row body-section">
                    <Sidebar
                      {...this.props}
                      {...this.state}                    />
                    <div className="right-side-container">{this.props.children}</div>
                  </div>
                </div>
              </section>
                <Footer {...this.props} />
            </>
          ) : null}
        </div>
      </>
    );
  }
}
const mapStateToProps: any = (state: IRootState) => ({
  loginReducer: state.loginReducer,
  configReducer: state.configReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onLogout: () => {
      dispatch(LogOutRequest());
    },
    getProfileInfo: () => {
      dispatch(getProfileRequest());
    },    
    getConfigInfo: (data: any) => {
      dispatch(getConfigRequest(data));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Layout);
